/* eslint-disable no-unused-vars */

import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../../api/api";
import { useState, useEffect } from "react";

import { CiMail } from "react-icons/ci";
import { LuArrowRight, LuArrowLeft } from "react-icons/lu";
import { CgSpinnerTwo } from "react-icons/cg";
import { FaRegCircleCheck } from "react-icons/fa6";

import { Toast } from "../../utils/Toast"

import './style.css'

export function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [password, setPassword] = useState('')
  const [passwordChanged, setPasswordChanged] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const sendPasswordRecordery = async () => {
    try {
      setIsLoading(true)
      if (!searchParams.get('auth')) {
        Toast.warning('Não foi possível recuperar a senha!')
        setIsLoading(false)
        return
      }

      await api.post('/users/update-password', { password }, {
        headers: {
          Authorization: `Bearer ${searchParams.get('auth')}`
        }
      })
      setPasswordChanged(true)
    } catch (error) {
      Toast.warning(error?.response?.data?.message, 3000)
    } finally {
      setIsLoading(false)

      setInterval(() => {
        Toast.success("Senha alterada, você será redirecionado para o login!")
        navigate('/')
      }, 5000);
    }
  }

  useEffect(() => {
    return () => {
      setPasswordChanged(false)
      setIsLoading(false)
    }
  }, [])

  return (
    <div className="container-recover-password">
      <div className="left-area">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div className="content-img-recover-password">
            <img className="logo-recover-password" src="./logo-sem-fundo.png" alt="Logo Unledu" />
          </div>

          <p style={{ margin: 0, fontWeight: 'bold', fontSize: '2rem', color: 'white' }}>Unledu</p>
        </div>

        <div>
          <p style={{ marginBottom: '1.5rem', fontWeight: 'bold', fontSize: '3.5rem', color: 'white', lineHeight: 1.2 }}> Recupere o acesso à sua conta</p>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '1rem', marginTop: '2rem' }}>
            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>Processo seguro</p>
            </div>

            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>Link temporário</p>
            </div>

            <div style={{ borderRadius: '15px', backgroundColor: '#fd6b33', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0.8rem' }}>
              <p style={{ margin: 0, fontWeight: '600', fontSize: '1rem', color: 'white' }}>Suporte 24h</p>
            </div>
          </div>
        </div>

        <div>
          <p style={{ margin: 0, fontSize: '1rem', lineHeight: 1, color: '#ffffff9c', fontWeight: 'bold' }}>© 2026 Unledu. Todos os direitos reservados.</p>
        </div>
      </div>

      <div className="right-area">
        <div style={{
          maxWidth: '400px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
          {!passwordChanged && (
            <div style={{ marginBottom: '32px' }}>
              <p style={{ marginBottom: '0.7rem', fontWeight: 'bold', fontSize: 'var(--font-size-page-title)', color: 'black', lineHeight: 1.2 }}>Recuperar senha</p>
              <p style={{ fontSize: 'var(--font-size-subtitle)', lineHeight: 1.4, color: '#616161' }}>Digite abaixo sua nova senha</p>
            </div>
          )}

          <div style={{
            zIndex: 10,
            width: '100%',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: 15,
            boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',

            ...(passwordChanged && {
              padding: '3rem 2rem',
            })
          }}>
            <div style={{ width: '100%' }}>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label" style={{ fontSize: 12, fontWeight: 'bold', color: '#3b3b3b' }}>Nova Senha</label>

                <div className="content-input">
                  <div style={{ width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute' }}>
                    <CiMail size={20} />
                  </div>

                  <input
                    type="email"
                    placeholder="123456" onChange={(e) => setPassword(e.target.value)} value={password}
                    className="form-control default-input-login" id="exampleInputEmail1"
                    aria-describedby="emailHelp" />
                </div>
              </div>

              <button
                className="btn btn-lg btn-dark-blue w-100"
                style={{
                  height: '40px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  color: 'white',
                  lineHeight: 1.2,
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  marginTop: '0.8rem',

                  ...(isLoading && {
                    opacity: 0.7,
                    cursor: 'default',
                    pointerEvents: 'none'
                  })
                }}
                onClick={sendPasswordRecordery}> {
                  isLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.3rem' }}>
                      <CgSpinnerTwo size={17} className="spinner-rotate" />

                      <p> Enviando...</p>
                    </div>
                  ) : (
                    <>
                      Alterar senha <LuArrowRight style={{ marginLeft: '0.5rem' }} />
                    </>
                  )}
              </button>
            </div>
          </div>

          {!passwordChanged && (
            <div onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', color: 'gray', margin: '4rem 0', cursor: 'pointer', fontWeight: '500', fontSize: 'var(--font-size-subtitle)' }}>
              <LuArrowLeft style={{ marginRight: '0.5rem' }} size={13} />
              <p className='m-0 p-0'>Acessar login</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
